


















































































import { Vue, Component, Prop } from 'vue-property-decorator';
import Role from '@/userManagement/Role';
import RoleType from '@/userManagement/RoleType';
import PermissionType from '@/userManagement/PermissionType';
import { COLLECTION_ROLES } from '@/model/AppConstants';
import Typekey from '@/userManagement/Typekey';

@Component({
  components: {},
})
export default class PerTableComp extends Vue {
  @Prop({ type: Object }) roleObj!: object;

  dialog = false;

  dialogDelete = false;

  deleteIndex = '';

  perObj = {};

  title = '';

  headers = [
    {
      text: 'Code',
      align: 'start',
      value: 'code',
    },
    { text: 'Name', value: 'name' },
    { text: 'Description', value: 'description' },
    { text: 'Actions', value: 'actions' },
  ];

  get permissions() {
    const Obj = this.$store.state.setRoleObj;
    this.title = Obj.roleType.name;
    return Obj.permissions;
  }
  // eslint-disable-next-line
  get permissionsItems() {
    return PermissionType.allPermissions();
  }

  deleteItem(item: any) {
    this.deleteIndex = this.permissions.indexOf(item);
    this.dialogDelete = true;
  }

  deleteItemConfirm() {
    this.permissions.splice(this.deleteIndex, 1);
    this.$store.dispatch('updateCollection', {
      collection: COLLECTION_ROLES,
      doc: this.$store.state.setRoleObj.id,
      payload: this.$store.state.setRoleObj,
    });
    this.closeDelete();
  }

  close() {
    this.dialog = false;
    // this.$nextTick(() => {
    //   // this.editedItem = Object.assign({}, this.defaultItem);
    //   // this.editedIndex = -1;
    // });
  }

  closeDelete() {
    this.dialogDelete = false;
    // this.$nextTick(() => {
    //   // this.editedItem = Object.assign({}, this.defaultItem);
    //   this.editedIndex = -1;
    // });
  }

  save() {
    const roleObj = { ...this.$store.state.setRoleObj };
    roleObj.id = this.$store.state.setRoleObj.id;
    roleObj.permissions.push({ ...this.perObj });
    this.$store.dispatch('updateCollection', {
      collection: COLLECTION_ROLES,
      doc: this.$store.state.setRoleObj.id,
      payload: roleObj,
    });
    this.close();
  }
}
